import React, { PropTypes } from 'react';
import { Navbar } from 'react-bootstrap';
import { Link, IndexLink } from 'react-router';

class ChartOfAccount extends React.Component {
   render() {
      return (
         <div className="ChartOfAccount" >
            <Navbar>
               <Navbar.Header>
                  <Navbar.Brand>
                     <Link to="/chartOfAccount/" activeStyle={{ color: 'red' }} >ChartOfAccount</Link>
                  </Navbar.Brand>
               </Navbar.Header>
               <ul className="nav navbar-nav" >
                  <li>
                     <IndexLink to="/chartOfAccount/" activeStyle={{ color: 'red' }} >All</IndexLink>
                  </li>
                  <li>
                     <Link to="/chartOfAccount/new" activeStyle={{ color: 'red' }} >New</Link>
                  </li>
               </ul>
            </Navbar>
            {this.props.children}
         </div>
      );
   }
}

ChartOfAccount.propTypes = {
   children: PropTypes.object
};

export default ChartOfAccount;



/** WEBPACK FOOTER **
 ** ./src/components/AccountingManagement/ChartOfAccount/ChartOfAccount.js
 **/